<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <div class="row">
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
            </b-form-group>
            <b-form-group label="Status:">
              <b-v-select
                v-model="formFilters.status"
                :options="statusListOpts"
              />
            </b-form-group>
            <b-form-group label="Fulfillment Service:">
              <b-v-select
                v-model="formFilters.fulfillmentService"
                :searchable="true"
                :options="fulfillmentServicesList"
              />
            </b-form-group>
            <b-form-group label="Requested Service:">
              <b-form-input v-model="formFilters.requestedService" />
            </b-form-group>
            <b-form-group label="Order Carrier Code:">
              <b-form-input v-model="formFilters.orderCarrierCode" />
            </b-form-group>
            <b-form-group label="Order Service Code:">
              <b-form-input v-model="formFilters.orderServiceCode" />
            </b-form-group>
            <b-form-group label="Fulfillment Carrier Code:">
              <b-form-input v-model="formFilters.fulfillmentCarrierCode" />
            </b-form-group>
            <b-form-group label="Fulfillment Service Code:">
              <b-form-input v-model="formFilters.fulfillmentServiceCode" />
            </b-form-group>
            <b-form-group label="Fulfillment Carrier Name:">
              <b-form-input v-model="formFilters.fulfillmentCarrierCode" />
            </b-form-group>
            <b-form-group label="Fulfillment Service Name:">
              <b-form-input v-model="formFilters.fulfillmentServiceCode" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Projects
            </h1>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'Admin.Projects.Create' }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(subDomain)="data">
        <a  v-if="data.item.mainDomain" class="btn btn-link" target="_blank" :href="'http://'+data.item.mainDomain">
          {{ data.item.mainDomain }}
        </a>
        <a v-else class="btn btn-link" target="_blank" :href="'http://'+data.item.subDomain+'.ux.app'">
          {{ data.item.subDomain }}.ux.app
        </a>
      </template>
      <template v-slot:cell(active)="data">
        <span v-if="data.item.active">Active</span>
        <span v-else>In-Active</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMMM Do YYYY h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMMM Do YYYY h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(id)="data">
        <button
          type="button"
          class="btn btn-info ml-1"
          @click="EditItem(data.item)"
        >
          Edit
        </button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Admin.Projects.Index',
  mixins: [crudMixinGen('projects'), myCommonDataMixin],
  components: {
    TableListing
  },

  data: () => ({
    statusListOpts: [
      {
        value: 'all',
        text: 'Show All'
      },
      {
        value: 'active',
        text: 'Only Active'
      },
      {
        value: 'inactive',
        text: 'Only Inactive'
      }
    ],
    fulfillmentServicesList: [
      {
        value: 'ShipStation',
        text: 'ShipStation'
      },
      {
        value: 'IRMS',
        text: 'IRMS'
      },
      {
        value: 'Landmark',
        text: 'Landmark'
      },
      {
        value: 'Crane',
        text: 'Crane'
      },
      {
        value: 'TPL',
        text: 'Extensiv'
      }
    ],
    fields: [
      { key: 'name', label: 'Name', sortable: false },
      { key: 'subDomain', label: 'Subdomain', sortable: false },
      { key: 'active', label: 'Status', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
    ]
  }),
  mounted() {
    this.loadItems();
  },

  methods: {
    EditItem(item) {
      this.$router.push({
        name: 'Admin.Projects.Edit',
        params: { id: item.id }
      });
    }
  }
};
</script>
